import { Theme } from "@emotion/react";
import {
  Components,
  createTheme,
  CssVarsTheme,
  PaletteOptions,
} from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import { customStyles } from "./theme-custom-styles";
import { CustomTheme } from "./theme.declarations";

const palette: PaletteOptions = {
  primary: {
    main: "#01346B",
  },
  secondary: {
    main: "#012144",
  },
  text: {
    primary: "#1A73E8",
  },
  background: {
    default: "#F7F7F7",
  },
  error: { main: "#DE3163", light: "#E12828" },
};

const custom: CustomTheme = {
  appDrawerWidth: "260px",
  appHeaderHeight: "60px",
  cardBoxShadow: "0px 2px 6px 0px rgba(76, 78, 100, 0.19)",
  appFooterHeight: "48px",
};

const typography: TypographyOptions = {
  fontWeightRegular: "400",
  button: {
    textTransform: "none",
  },
};

const components: Components<
  Omit<Theme, "components" | "palette"> & CssVarsTheme
> = {
  MuiSnackbarContent: {
    styleOverrides: {
      root: {
        justifyContent: "center",
        background: "#01346B",
        fontWeight: "400",
      },
    },
  },
};

export const theme = createTheme({
  palette,
  custom,
  typography,
  customStyles,
  components,
});
